import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Handles cart update events and announces the new count to screen readers.
   * @param {CustomEvent<{ resource?: { item_count?: number, items?: Array<{ variant_id?: number, quantity?: number, properties?: Record<string, string> }> }, data?: { displayItemCount?: number } }>} event
   */
  #onCartUpdate = (event) => {
    const cartCount = event.detail.data?.displayItemCount ?? this.#visibleCartCount(event.detail.resource);
    if (cartCount === undefined) return;

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };

  #visibleCartCount(cart) {
    if (!cart?.items) return cart?.item_count;

    return cart.items.reduce((count, item) => {
      const properties = item.properties || {};
      const isExtraPhoto =
        Number(item.variant_id) === 57427065602379 ||
        properties._cryela_locked === 'true' ||
        properties.Motivo === 'Foto extra personalizzazione';

      return count - (isExtraPhoto ? Number(item.quantity || 0) : 0);
    }, Number(cart.item_count || 0));
  }
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
